import { Icon, Tooltip, TooltipContent, TooltipTrigger } from "@nexus/ui"
import { useTranslation } from "react-i18next"
import { getDualSpendDisplay } from "../lib/dual-spend-display"

export function DualSpendValue({
  perDataset,
  totalCreatives,
  decimals = 1,
  className,
}: {
  perDataset: number | null
  totalCreatives: number | null
  decimals?: number
  className?: string
}) {
  const { t } = useTranslation()
  const display = getDualSpendDisplay(perDataset, totalCreatives, decimals)

  return (
    <span className={className}>
      <span className="block font-mono tabular-nums text-sm text-muted-foreground">
        {display.primary}
      </span>
      {display.secondaryValue && (
        <span className="block text-[10px] leading-tight text-muted-foreground/70">
          {t("opportunities.spend.totalCreativesLabel", {
            value: display.secondaryValue,
            defaultValue: "{{value}} of total creatives",
          })}
        </span>
      )}
    </span>
  )
}

export function DualSpendValueWithTooltip({
  perDataset,
  totalCreatives,
  decimals = 1,
}: {
  perDataset: number | null
  totalCreatives: number | null
  decimals?: number
}) {
  const { t } = useTranslation()
  const display = getDualSpendDisplay(perDataset, totalCreatives, decimals)
  const naTooltip = t("opportunities.drawer.spendUnavailableTooltip")

  if (!display.unavailable) {
    return <DualSpendValue perDataset={perDataset} totalCreatives={totalCreatives} decimals={decimals} />
  }

  return (
    <span className="inline-flex items-center gap-1 font-mono text-sm text-muted-foreground">
      {display.primary}
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-flex cursor-help">
            <Icon name="info" size="xs" className="text-muted-foreground/50" />
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-xs">{naTooltip}</TooltipContent>
      </Tooltip>
    </span>
  )
}
